import { React, useEffect } from 'react';
import  coverImage  from '../../../images/welcome.jpg';
import './Welcome.css';
import { CurrentUserContext } from "../../../context/CurrentUserContext";
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

function CoverPage({user}) {
  const { currentUser } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/content');   /*content yerine your learning journey - grid 9 - 12 kurs  bu gridin aynisi log olmadan olan sayfada da olursa hallederiz*/
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/content');
    }, 8000);
    return () => clearTimeout(timer);
  }, [navigate]);
  
  return(
    <main className='mainCover'>
      <img className="cover" src={coverImage} onClick={handleClick}></img>
      <div className="bubbleContainer">
        <div className="bubble">
          <span>WELCOME!</span>
          <p className="first"> START LEARNING</p>
          <p className="second">TO BUILD YOUR FUTURE</p>
        </div>
      </div>
    </main>
  )
}

export default CoverPage;